import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import { ProductCTAConstants } from './constants'
import styles from './productCTA.module.scss'
import { DisplayTextType } from './types'

export const ProductDisplayText = ({ date, className, isQuickATCForMobile, showNewPdpUI }: DisplayTextType) => {
  const { t } = useTranslation('common')
  return (
    <div
      className={classNames(
        styles.displayTextWrapper,
        className,
        isQuickATCForMobile && styles.displayTextWrapper__quickATC,
        showNewPdpUI && styles.displayTextWrapper_adjustedPadding,
      )}
    >
      {ProductCTAConstants.OUT_OF_STOCK}
      {date ? t('var1_date', { var1: ProductCTAConstants.BACK_IN_STOCK, date: date }) : ''}
    </div>
  )
}
